"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesDocs = void 0;
const core_1 = require("@beautiful-eyes/core");
const templates_template_be_1 = __importDefault(require("./templates.template.be"));
let TemplatesDocs = (() => {
    let _classDecorators = [(0, core_1.Component)({
            selector: 'TemplatesDocs',
            useTemplate: templates_template_be_1.default,
            useStyleSheets: []
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = core_1.ReactiveClass;
    let _showMessage_decorators;
    let _showMessage_initializers = [];
    let _showMessage_extraInitializers = [];
    let _demoItems_decorators;
    let _demoItems_initializers = [];
    let _demoItems_extraInitializers = [];
    var TemplatesDocs = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.showMessage = __runInitializers(this, _showMessage_initializers, false);
            this.demoItems = (__runInitializers(this, _showMessage_extraInitializers), __runInitializers(this, _demoItems_initializers, ['Alpha', 'Bravo', 'Charlie']));
            this.introSample = (__runInitializers(this, _demoItems_extraInitializers), `<!-- todo-list.template.be -->
<h1>Todo list ({remaining} left)</h1>
<ul>
@for(item : items; key = trackById){
  <li>
    <TodoItem $label={item.label} $done={item.done} @onToggle={() => toggleItem(item.id)} />
  </li>
}
</ul>`);
            this.elementsSample = `<div>hello</div>
<input value="x" />`;
            this.interpolationSample = `<div>{count}</div>
<div>{count + 1}</div>
<div>{isDone ? 'done' : 'pending'}</div>`;
            this.eventSample = `<button @click={handleClick}>click me</button>
<button @click={() => this.count++}>+1</button>`;
            this.ifSample = `@if(count % 2 === 0){
  <span>even</span>
}
@else-if(count % 3 === 0){
  <span>divisible by 3</span>
}
@else{
  <span>odd</span>
}`;
            this.forSample = `@for(item : items){
  <li>{item}</li>
}

@for(index, item : items; key = trackById){
  <li>{index}: {item.label}</li>
}`;
            this.trackBySample = `class TodoList extends ReactiveClass {
    @State() items = [{ id: 1, label: 'Write docs' }];

    trackById(item: { id: number }){
        return item.id;
    }
}`;
        }
        toggleMessage() {
            this.showMessage = !this.showMessage;
        }
        addItem() {
            this.demoItems = [...this.demoItems, 'Item ' + (this.demoItems.length + 1)];
        }
        removeItem() {
            this.demoItems = this.demoItems.slice(0, -1);
        }
    };
    __setFunctionName(_classThis, "TemplatesDocs");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _showMessage_decorators = [(0, core_1.State)()];
        _demoItems_decorators = [(0, core_1.State)()];
        __esDecorate(null, null, _showMessage_decorators, { kind: "field", name: "showMessage", static: false, private: false, access: { has: obj => "showMessage" in obj, get: obj => obj.showMessage, set: (obj, value) => { obj.showMessage = value; } }, metadata: _metadata }, _showMessage_initializers, _showMessage_extraInitializers);
        __esDecorate(null, null, _demoItems_decorators, { kind: "field", name: "demoItems", static: false, private: false, access: { has: obj => "demoItems" in obj, get: obj => obj.demoItems, set: (obj, value) => { obj.demoItems = value; } }, metadata: _metadata }, _demoItems_initializers, _demoItems_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        TemplatesDocs = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return TemplatesDocs = _classThis;
})();
exports.TemplatesDocs = TemplatesDocs;
